import {
  CardPageBackButton,
  CardPageHeading,
  CardPageIllustration,
  CardPageSubtitle,
} from '@gamma/ui/pages';
import { useNavigate } from 'react-router';
import { i18n } from '../../../../shared/localization';

export const TwoFactorRecovery = () => {
  const navigate = useNavigate();

  const { title, subtitle } = i18n.pages.twoFactorRecovery;

  return (
    <>
      <CardPageBackButton onClick={() => navigate('/login/trouble')} />
      <CardPageHeading>{title}</CardPageHeading>
      <CardPageIllustration
        illustration={'TwoFactorAuth'}
        width="160px"
        height="128px"
      />
      <CardPageSubtitle>{subtitle}</CardPageSubtitle>
    </>
  );
};
